import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './functions';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (n, e) => !(e instanceof ApiError && e.status < 500) && n < 2,
    },
  },
});

/** Clés de cache centralisées (invalidation ciblée). */
export const cles = {
  session: ['session'] as const,
  referentiels: ['referentiels'] as const,
  dashboard: ['dossiers', 'dashboard'] as const,
  dossier: (id: string) => ['dossiers', id] as const,
  lignes: (dossierId: string) => ['dossiers', dossierId, 'lignes'] as const,
  sources: (ligneId: string) => ['lignes', ligneId, 'sources'] as const,
  run: (ligneId: string) => ['lignes', ligneId, 'run'] as const,
  dispos: (expertId: string) => ['dispos', expertId] as const,
  pieces: (dossierId: string) => ['dossiers', dossierId, 'pieces'] as const,
};
